import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";

class BackButton extends Component {
  back() {
    this.props.path
      ? window.location.replace(this.props.path)
      : window.history.back();
  }
  render() {
    return (
      <div className="d-inline-block" onClick={() => this.back()}>
        <FiChevronRight className="ms-2" size="22" />
        <span className="fs-6 fw-bolder" style={{ verticalAlign: "sub" }}>
          برگشت
        </span>
      </div>
    );
  }
}

export default BackButton;
